<template>
    <a
        :class="'automation-play-now-cta '+css" rel="nofollow" target="_blank"
        :href="offer.link.exit_page | appendfragment('cta', cta)"
        :data-gtm="gtm"
        data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
        :data-ctalocation="ctaLocation"
        :data-operator="offer.product.brand_name"
        :data-product="offer.product.brand_product_name"
        :data-offer="stripTags(offer.offer.offer_short_description)"
        :data-brand_id="offer.product.brand_id"
        :data-brand_product_id="offer.product.brand_product_id"
        :data-offer_id="offer.offer.offer_id"
        :data-site_offer_id="offer.offer.site_offer_id"
        v-if="isValidDestinationLink"
    >
        <slot>

        </slot>
    </a>
</template>

<script>
export default {
    name: 'exit-link-button-elements',
    props: {
        offer: {
            type: Object,
            require: true
        },
        state: {
            type: String,
            require: false
        },
        cta: {
            type: String,
            require: true
        },
        ctaLocation: {
            type: String,
            require: true
        },
        gtm: {
            type: String,
            require: true
        },
        css: {
            type: String,
            default: "btn-cta-play-now exit-page-link"
        }
    },
    data: function () {
        return {
            isValidDestinationLink: false,
        }
    },
    mounted: function () {
        this.fetchLink();
    },
    methods: {
        fetchLink() {
            this.isValidDestinationLink = false;
            if (Object.keys(this.offer).length === 0) {
                return false;
            } else {
                this.isValidDestinationLink = this.offer.link.exit_page ?? true;
            }
        },
        stripTags(text) {
            return text.replace(/<\/?[^>]+>/ig, "");
        }
    },
    watch: {
        state() {
            this.fetchLink();
        }
    },
};
</script>
